module.exports = __webpack_public_path__ + "img/ZBT3000.3035dbf8.png";